module.exports = __webpack_public_path__ + "static/img/error.b87756e.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/error.gif
// module id = VWqt
// module chunks = 104